// Key are the subdomains && values are the broker['id']
export enum ACTIVE_BROKERS_DOMAINS {
  ANGELONE = 'angel_broking',
  ALICEBLUE = 'aliceblue',
  PAYTMMONEY = 'paytm',
  ICICIDIRECT = 'icici_direct',
  GOODWILL = 'goodwill',
  BIGUL = 'bigul',
  DHAN = 'dhan',
  NUVAMA = 'nuvama',
  ENRICHMONEY = 'enrich_money',
  KOTAKNEO = 'kotak_neo',
  SHAREKHAN = 'sharekhan',
  RUPEEZY = 'rupeezy',
  PHILLIPCAPITAL = 'philip_capital',
  SAMCO = 'samco',
  UPSTOX = 'upstox',
  INVESTRIGHT = 'invest_right',
  HDFCSKY = 'hdfcsky',
  '5PAISA' = 'fivepaisa',
  GROWW = 'groww',
  RELIGARE = 'religare',
  ZDHA = 'zerodha',
  FLATTRADE = 'flattrade',
  FINVASIA = 'finvasia',
  FYERS = 'fyers',
  ZEBU = 'zebull',
  DHANISTOCKS = 'ibulls_securities',
  IIFL = 'iifl',
  JAINAMLITE = 'jainam_lite',
  STOXKART = 'stoxkart',
  KBS = 'kbs',
  ARIHANTPLUS = 'arihant_plus',
  STOCKO = 'stocko',
  DELTAEXCHANGE = 'delta_exchange',
  COIN_DCX = 'coin_dcx'
}
